import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { getDomain } from "../../utils/constants";

const StartCheckin: React.FC = () => {
  const { appointmentId } = useParams<{ appointmentId: string }>();

  useEffect(() => {
    if (!appointmentId) {
      return;
    }

    // Call the API - get redirect URL from Location header to avoid CORS issues
    const apiUrl = `${getDomain()}/api/athena/digital-checkin/start-checkin/${encodeURIComponent(appointmentId)}`;
    
    // Use fetch with redirect: 'manual' to get the Location header without CORS issues
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'client': 'axis',
        'domain': 'axis',
      },
      redirect: 'manual', // Don't follow redirect automatically to avoid CORS
    }).then((response) => {
      // Extract redirect URL from Location header
      const redirectUrl = response.headers.get('Location');
      
      if (redirectUrl) {
        // Navigate using window.location.href - this doesn't have CORS restrictions
        window.location.href = redirectUrl;
      } else {
        // If no redirect URL, try to navigate to the response URL
        window.location.href = response.url;
      }
    });
  }, [appointmentId]);

  return (
    <div className="min-h-screen bg-[#F7F8FD] flex flex-col">
      <div className="flex flex-row px-10 py-6 shadow justify-between bg-white items-center">
        <span className="text-[#01545D] font-semibold text-2xl">
          Axis Integrated Mental Health
        </span>
        <span className="text-[#01545D] font-medium text-xl">Patient Check-In</span>
      </div>
      <main className="flex-grow container mx-auto flex flex-col items-center justify-center px-4 py-10">
        <div className="flex flex-col items-center">
          <div className="text-4xl font-semibold text-[#01545D] text-center mb-3">
            Starting Check-In
          </div>
          <div className="text-xl text-[#1C1C1C] text-center mb-6">
            Please wait while we prepare your check-in...
          </div>
          <div className="text-sm text-[#5D6A85] mb-2">Loading...</div>
          <div className="mt-4">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#01545D]"></div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default StartCheckin;
